export const revokeXhsNotePreviewUrl = (previewUrlByUidRef, uid) => {
  try {
    const map = previewUrlByUidRef?.current;
    const url = map?.get(uid);
    if (url) {
      URL.revokeObjectURL(url);
      map.delete(uid);
    }
  } catch (_) {
    // ignore
  }
};

export const getXhsNotePreviewUrl = (previewUrlByUidRef, file) => {
  try {
    const uid = file?.uid;
    if (!uid) return '';
    const map = previewUrlByUidRef?.current;
    const cached = map?.get(uid);
    if (cached) return cached;
    const fileObj = file?.originFileObj || file;
    if (!fileObj) return '';
    const url = URL.createObjectURL(fileObj);
    map.set(uid, url);
    return url;
  } catch (_) {
    return '';
  }
};

export const normalizeXhsImageFileList = (newFileList = []) => {
  const next = Array.isArray(newFileList) ? newFileList.slice(0, 18) : [];
  const truncated = (newFileList || []).length > 18;
  return { next, truncated };
};

export const readXhsNoteDragUid = (e) => {
  try {
    return (
      e?.dataTransfer?.getData('application/xhsnote-image-uid')
      || e?.dataTransfer?.getData('text/plain')
      || null
    );
  } catch (_) {
    return null;
  }
};

export const reorderXhsImagesOnTarget = ({ list = [], fromUid, targetUid, position = 'before' }) => {
  if (!fromUid || !targetUid || fromUid === targetUid) return list;
  const next = [...list];
  const fromIdx = next.findIndex((item) => item.uid === fromUid);
  const toIdx = next.findIndex((item) => item.uid === targetUid);
  if (fromIdx < 0 || toIdx < 0) return list;
  const [moved] = next.splice(fromIdx, 1);
  const adjustedToIdx = fromIdx < toIdx ? toIdx - 1 : toIdx;
  const insertAt = position === 'after' ? adjustedToIdx + 1 : adjustedToIdx;
  next.splice(Math.max(0, Math.min(insertAt, next.length)), 0, moved);
  return next;
};

export const reorderXhsImagesToEnd = ({ list = [], fromUid }) => {
  if (!fromUid) return list;
  const next = [...list];
  const fromIdx = next.findIndex((item) => item.uid === fromUid);
  if (fromIdx < 0) return list;
  const [moved] = next.splice(fromIdx, 1);
  next.push(moved);
  return next;
};

export const buildXhsSummaryParams = (values = {}) => ({
  title: String(values.title || '').trim(),
  body: String(values.body || '').trim(),
});

export const buildXhsTagsParams = (values = {}) => ({
  title: String(values.title || '').trim(),
  body: String(values.body || '').trim(),
  summary: String(values.summary || '').trim(),
});

export const buildXhsCreateFormData = ({ values = {}, imageFileList = [] }) => {
  const formData = new FormData();
  formData.append('title', String(values.title || '').trim());
  formData.append('body', String(values.body || '').trim());
  if (String(values.summary || '').trim()) {
    formData.append('summary', String(values.summary || '').trim());
  }
  if (Array.isArray(values.tags) && values.tags.length > 0) {
    formData.append('tags', values.tags.join(','));
  }
  for (const file of imageFileList) {
    const fileObj = file?.originFileObj || file;
    if (fileObj) formData.append('images', fileObj);
  }
  return formData;
};
